import { render, staticRenderFns } from "./CardProjectsetting.vue?vue&type=template&id=0b30c874&scoped=true&"
import script from "./CardProjectsetting.vue?vue&type=script&lang=js&"
export * from "./CardProjectsetting.vue?vue&type=script&lang=js&"
import style0 from "./CardProjectsetting.vue?vue&type=style&index=0&id=0b30c874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b30c874",
  null
  
)

export default component.exports